<template>
    <div  class="modal-overlay">
        <div class="modal-box" v-click-outside="onCancel">
            <div class="icon-wrapper">
                <svg viewBox="0 0 24 24" width="64" height="64" stroke="#f39c12" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <circle cx="12" cy="16" r="1"></circle>
                </svg>
            </div>
            <h2 class="title">{{ $t("message.trialWillEnd") }}</h2>
            <p class="description">
                {{ $t("message.trialEndConfirmDescription") }}
            </p>
            <div class="button-group">
                <SupsisButton ghost @click="onCancel">{{ $t("common.cancel") }}</SupsisButton>
                <SupsisButton primary @click="onConfirm">{{ $t("message.confirmAndContinue") }}</SupsisButton>
            </div>
        </div>
    </div>
</template>

<script>
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import clickOutside from "@/directives/clickOutside";

export default {
    name: "TrialEndConfirmationModal",
    components: {
        SupsisButton,
    },
    directives: {
        clickOutside,
    },
    data() {
        return {
            mountedTime: Date.now(),
        };
    },
    methods: {
        onConfirm() {
            this.$emit('confirm');
        },
        onCancel() {
            if (Date.now() - this.mountedTime < 100) return;
            this.$emit('cancel');
        },
    },
    mounted() {
        this.mountedTime = Date.now();
    },
};
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    backdrop-filter: blur(2px);
}

.modal-box {
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 480px;
    padding: 48px 40px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 24px;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    0% {
        opacity: 0;
        transform: translateY(-20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.icon-wrapper {
    background: #fff3cd;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-text-strong-default);
    margin: 0;
}

.description {
    font-size: 16px;
    color: var(--color-text-default);
    max-width: 420px;
    line-height: 1.6;
}

.button-group {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
}

::v-deep .supsis-button {
    min-width: 140px;
    height: 44px;
    font-size: 16px;
}
</style> 